import { COLOR_MAP } from '@nile/components';
import { Button, ButtonGroup } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ActionGroup = (props) => {
  const {
    secondaryAction,
    secondaryText = <FormattedMessage id="common.cancel" />,
    secondaryLoading,
    primaryAction,
    primaryText = <FormattedMessage id="common.save" />,
    primaryLoading,
    superId = 'ActionGroup',
    primaryIcon = <SVGIcon name="Save" color={COLOR_MAP.white} />,
    primaryDisabled,
    onlyPrimary,
    onlySecondary = false
  } = props;
  return (
    <span superid={superId}>
      <ButtonGroup>
        {!onlyPrimary && (
          <Button
            plainSecondary
            onClick={secondaryAction}
            loading={secondaryLoading}
          >
            {secondaryText}
          </Button>
        )}
        {!onlySecondary && (
          <Button
            primary
            id="actionGroupSaveEmail"
            loading={primaryLoading}
            onClick={primaryAction}
            icon={!primaryLoading && primaryIcon}
            disabled={primaryDisabled}
          >
            {!primaryLoading ? (
              primaryText
            ) : (
              <FormattedMessage id="common.save" />
            )}
          </Button>
        )}
      </ButtonGroup>
    </span>
  );
};

export default ActionGroup;
